import request from './NetworkLayer';

export default function switchToLatestVersion(
  userId,
  companyId,
  contentId,
  contentType,
  currentVersionId,
  switchToVersionId
) {
  window.analytics
    && window.analytics.track('SWITCH_TO_LATEST_VERSION', {
      contentId,
      contentType,
      currentVersionId,
      switchToVersionId,
      userId
    });
  const requestData = {
    type: 'switchToLatestContent',
    switchToLatestContentParams: {
      userId,
      companyId,
      actorId: userId,
      timeStamp: new Date().toISOString(),
      contentId,
      contentType
    },
    sync: true
  };

  return request(
    '/syncMutations',
    {
      method: 'POST',
      body: JSON.stringify(requestData)
    },
    {
      removeApiEndpoint: true
      // dontSendAuthHeader: true
    }
  );
}
